import { Slide } from "@jelly/lesson";

import { task as task01 } from "../../../../../task/course-01/lesson-30/task-01";

const task: Slide = {
  titleHtml:
    "A loudspeaker connected to an exponential horn is used to emit an alarm signal. The alert signal emits<br>complex signals of frequencies higher than 50 Hz. We try to dimension the horn. The celerity in air is<br>340 m/s. Calculate the coefficient of the exponential m such that the cutoff frequency of the infinite<br>horn is 20 Hz. Calculate the length L of the horn so that it is equal to a quarter wavelength at a<br>frequency of 20 Hz. Calculate the outlet diameter D of the horn when its entrance diameter is 100 mm.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task01.id,
        },
      },
    },
  },
};

export default task;
